module.exports = __webpack_public_path__ + "static/media/app-logo.afebf61f.png";